import { render, staticRenderFns } from "./card-user.vue?vue&type=template&id=538a0e28&scoped=true&"
import script from "./card-user.vue?vue&type=script&lang=js&"
export * from "./card-user.vue?vue&type=script&lang=js&"
import style0 from "./card-user.vue?vue&type=style&index=0&id=538a0e28&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a0e28",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VAvatar,VCard,VCardActions,VCardSubtitle,VCardTitle})
